<div
  class="scroll vi-primary vi-hue-1 print-content no-print-flexbox udp-content internal"
  #pdfPage
  [style.--size.px]="pageHeight"
  *ngIf="!loading"
>
  <div layout="column" class="page">
    <div class="page-break"></div>

    <div class="report-header">
      <img *ngIf="!isPcClientView" src="{{ logoUrl }}" class="truespeed-logo" />
      <h2 class="truespeed-title">{{ reportTitle }}</h2>
    </div>

    <hr />
    <div class="margin-10-left" *ngIf="!isPcClientView">
      <div style="margin-top: 10px; line-height: 1.6">
        <div class="header-style">
          <div class="header-class">Test Name</div>
          <div class="value-font">
            {{ requestInfo?.testName }}
          </div>
        </div>
        <div class="header-style">
          <div class="header-class">Test Mode</div>
          <div class="value-font">
            {{ testMode }}
          </div>
        </div>
        <div class="header-style">
          <div class="header-class">Start Date</div>
          <div class="value-font">{{ startDate }}</div>
        </div>
        <div class="header-style">
          <div class="header-class">End Date</div>
          <div class="value-font">{{ stopDate }}</div>
        </div>
        <div class="header-style">
          <div class="header-class">Duration</div>
          <div class="value-font">{{ duration }}</div>
        </div>
        <div class="header-style" *ngIf="overallConfiguration">
          <div class="header-class">Test Points</div>
          <div class="value-font">
            {{ overallConfiguration.agent.primary.id }}
          </div>
        </div>
        <div
          class="header-style"
          *ngIf="
            overallConfiguration &&
            overallConfiguration.agent.secondary &&
            overallConfiguration.agent.secondary.length > 0
          "
        >
          <div class="header-class"></div>
          <div
            class="value-font"
            *ngIf="
              overallConfiguration &&
              overallConfiguration.agent.secondary &&
              overallConfiguration.agent.secondary.length > 0
            "
          >
            {{ overallConfiguration.agent.secondary[0].id }}
          </div>
        </div>
      </div>
      <div style="margin-top: 10px; line-height: 1.6">
        <div class="header-style" *ngIf="requestInfo.mode === 'CLIENT-TO-MA' && requestInfo.dmzUrl">
          <div class="header-class">DMZ Test URL</div>
          <div class="value-font">
            {{ requestInfo.dmzUrl }}
          </div>
        </div>
        <div
          class="header-style"
          *ngIf="
            requestInfo.mode === 'CLIENT-TO-MA' && requestInfo.vtaTsUrl && overallConfiguration
          "
        >
          <div class="header-class">{{ getAgentURLLabel() }}</div>
          <div class="value-font">
            {{ requestInfo.vtaTsUrl }}
          </div>
        </div>
      </div>
      <div
        *ngIf="
          requestInfo?.customerInfo?.name ||
          requestInfo?.customerInfo?.contact ||
          requestInfo?.customerInfo?.phone ||
          requestInfo?.customerInfo?.email
        "
      >
        <div class="reports-customer-info">
          <div class="info-title">Customer</div>
          <div class="info-container">
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.name">
              <div class="sec-header">Name</div>
              <div class="sec-value">{{ requestInfo.customerInfo.name }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.contact">
              <div class="sec-header">Contact</div>
              <div class="sec-value">{{ requestInfo.customerInfo.contact }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.email">
              <div class="sec-header">Email</div>
              <div class="sec-value">{{ requestInfo.customerInfo.email }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.phone">
              <div class="sec-header">Phone</div>
              <div class="sec-value">{{ requestInfo.customerInfo.phone }}</div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="requestInfo?.techInfo?.name || requestInfo?.techInfo?.id">
        <div class="reports-customer-info">
          <div class="info-title">Technician</div>
          <div class="info-container">
            <div class="details-sec" *ngIf="requestInfo?.techInfo?.name">
              <div class="sec-header">Name</div>
              <div class="sec-value">
                {{ requestInfo?.techInfo?.name }}
              </div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.techInfo?.id">
              <div class="sec-header">ID</div>
              <div class="sec-value">
                {{ requestInfo?.techInfo?.id }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 30px" *ngIf="requestInfo?.comments">
        <div class="header-style">
          <div class="header-class">Comments</div>
          <div class="value-font">
            {{ requestInfo.comments }}
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 30px; margin-left: 10px">
      <div class="header-style">
        <div class="header-class">Summary</div>
        <div class="pass-color" *ngIf="overallResult === 'Pass'">TEST PASSED</div>
        <div class="fail-color" *ngIf="overallResult === 'Fail'">
          TEST FAILED
          <div class="fail-color-3" *ngIf="errorMessage">{{ errorMessage }}</div>
        </div>

        <div class="unknown-color" *ngIf="overallResult === 'Inconclusive'">TEST INCONCLUSIVE</div>
        <div class="unknown-color" *ngIf="overallResult === 'Unknown'">
          TEST {{ controllerStatus }}
        </div>
      </div>
    </div>
  </div>

  <div layout="column" class="page" *ngIf="finalReport">
    <div class="page-break"></div>
    <div class="header-row">
      <div class="header-font-2">
        <img class="icon" [attr.src]="'images/SPTIcon.svg'" />
        <span class="margin-10-left"> Results</span>
      </div>
      <div class="checkbox-container">
        <div *ngFor="let type of getAvailableDataTypes()" class="checkbox-item">
          <mat-checkbox
            color="primary"
            [checked]="existsDataType(type)"
            (change)="toggleDataType(type, $event.checked)"
          >
            {{ type }}
          </mat-checkbox>
        </div>
      </div>
    </div>
    <hr />

    <ng-container *ngFor="let originator of getAvailableOriginators()">
      <div>
        <div *ngIf="originator === 'engine-a'" class="direction">
          A <i class="mdi mdi-arrow-right-bold onewayBColor"></i> B
        </div>

        <div *ngIf="originator === 'engine-b'" class="direction">
          B <i class="mdi mdi-arrow-right-bold onewayAColor"></i> A
        </div>
      </div>

      <div class="field-style">
        <table class="sp-table" style="width: 100%">
          <!-- Table Header -->
          <thead>
            <tr>
              <th class="header-top-color">Name</th>
              <th *ngIf="!isPcClientView" class="header-top-color">Result</th>
              <th class="header-top-color">{{ streamRateConvention }}</th>
              <th class="header-top-color">UDP BW</th>
              <th *ngIf="!isPcClientView" class="header-top-color">Packet Loss</th>
              <th *ngIf="!isPcClientView" class="header-top-color">Packet Counts</th>
              <th class="header-top-color">RTT Results(ms)</th>
              <th *ngIf="!isPcClientView" class="header-top-color">Jitter Results(ms)</th>
            </tr>
          </thead>

          <!-- Table Body -->
          <tbody style="font-size: 13px">
            <ng-container *ngFor="let row of orderByStream(finalReport[originator])">
              <tr>
                <td>
                  <div class="bold-font">
                    {{ getStreamName(row['stream-number']) }}
                    <div class="normal-font" *ngIf="row['stream-number'] !== 'Aggregate'">
                      ({{ getStreamFrameSize(row['stream-number']) }} bytes,
                      {{ getStreamType(row['stream-number']) }})
                    </div>
                  </div>
                </td>
                <td *ngIf="!isPcClientView">
                  <label>
                    <i
                      [ngClass]="
                        row.verdict === 'pass'
                          ? 'mdi mdi-check-circle pass-color'
                          : row.verdict === 'fail'
                          ? 'mdi mdi-close-circle fail-color'
                          : ''
                      "
                      style="font-size: 20px"
                    ></i>
                  </label>
                </td>
                <td>
                  <div>{{ row['ulr-or-ir'] | number: '1.2-2' }} <span>Mbps </span></div>
                </td>
                <td>
                  <div class="bold-font">
                    {{ row['average-thruput'] | number: '1.2-2' }}
                    <span class="normal-font">Mbps</span>
                  </div>
                </td>
                <td *ngIf="!isPcClientView">
                  <div
                    class="bold-font"
                    [ngClass]="row['packet-loss-ratio-verdict'] === 'fail' ? 'fail-color' : ''"
                  >
                    {{ row['packet-loss-ratio'] }}
                    <span class="normal-font">%</span>
                  </div>
                </td>
                <td *ngIf="!isPcClientView">
                  <div *ngIf="row['tx-packet-count']">Tx: {{ row['tx-packet-count'] }}</div>
                  <div *ngIf="row['rx-packet-count']">Rx: {{ row['rx-packet-count'] }}</div>
                  <div *ngIf="row['packet-loss-count']">Lost: {{ row['packet-loss-count'] }}</div>
                </td>
                <td *ngIf="row['stream-number'] !== 'Aggregate'">
                  <div *ngIf="row['minimum-rtt']">Min: {{ row['minimum-rtt'] }}</div>
                  <div *ngIf="row['average-rtt']">Avg: {{ row['average-rtt'] }}</div>
                  <div *ngIf="row['maximum-rtt']">Max: {{ row['maximum-rtt'] }}</div>
                </td>
                <ng-container *ngIf="row['stream-number'] !== 'Aggregate'">
                  <td *ngIf="!isPcClientView">
                    <div *ngIf="row['minimum-jitter']">Min: {{ row['minimum-jitter'] }}</div>
                    <div *ngIf="row['average-jitter']">Avg: {{ row['average-jitter'] }}</div>
                    <div *ngIf="row['maximum-jitter']">Max: {{ row['maximum-jitter'] }}</div>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div *ngIf="trendingResults" style="margin-top: 20px">
        <ng-container *ngIf="selectedDataType.length > 0">
          <ng-container *ngFor="let dataType of selectedDataType">
            <div
              class="trending-chart-container"
              [id]="'chart-' + originator + '-' + dataType.replace(' ', '-')"
            ></div>
          </ng-container>
        </ng-container>
      </div>
      <hr />
    </ng-container>
  </div>

  <div layout="column" class="page" *ngIf="testConfig && !isPcClientView">
    <div class="page-break"></div>
    <div class="header-font-2">
      <i class="material-icons icon">settings</i>
      <span class="margin-10-left">Test Configuration</span>
    </div>
    <hr />

    <div class="test-margin">
      <div class="test-font">Endpoints</div>
      <div style="width: 70%">
        <table
          style="border-left: unset; border-right: unset; font-size: 14px; width: 100%"
          class="test-setup-table"
        >
          <tr>
            <td class="test-bold-color">
              Test Point
              <span *ngIf="testConfig['udp:udp']['engine-a-info']"> A</span>
            </td>
            <td></td>
          </tr>
          <tr>
            <td class="test-color">Name</td>
            <td>
              {{ overallConfiguration?.agent.primary.id }}
            </td>
          </tr>
          <tr *ngIf="testConfigDisplay?.tpaVersion">
            <td class="test-color">Version</td>
            <td>{{ testConfigDisplay.tpaVersion }}</td>
          </tr>
          <tr>
            <td class="test-color">Agent Type</td>
            <td>
              {{ testConfig['udp:udp']['engine-a-info']['engine-type'] }}
            </td>
          </tr>
          <tr>
            <td class="test-color">Management Address</td>
            <td>{{ testConfig['udp:udp']['engine-a-info'].address }}</td>
          </tr>
          <tr>
            <td class="test-color">Management Port</td>
            <td>{{ testConfig['udp:udp']['engine-a-info'].port }}</td>
          </tr>

          <tr>
            <td class="test-color">Test Address</td>
            <td>
              {{ testConfig['udp:udp']['engine-a-info']['test-ip'] }}
            </td>
          </tr>
          <tr>
            <td class="test-color">Test Subnet Mask</td>
            <td>
              {{ testConfig['udp:udp']['engine-a-info']['test-subnet-mask'] }}
            </td>
          </tr>
          <tr>
            <td class="test-color">Test Gateway</td>
            <td>
              {{ testConfig['udp:udp']['engine-a-info']['test-gateway'] }}
            </td>
          </tr>
        </table>
        <table
          *ngIf="testConfig['udp:udp']['engine-b-info']"
          style="
            border-left: unset;
            border-right: unset;
            margin-top: 20px;
            font-size: 14px;
            width: 100%;
          "
          class="test-setup-table"
        >
          <tr>
            <td class="test-bold-color">Test Point B</td>
            <td></td>
          </tr>
          <tr>
            <td class="test-color">Name</td>
            <td>
              {{ overallConfiguration.agent.secondary[0].id }}
            </td>
          </tr>
          <tr *ngIf="testConfigDisplay?.tpbVersion">
            <td class="test-color">Version</td>
            <td>{{ testConfigDisplay.tpbVersion }}</td>
          </tr>
          <tr>
            <td class="test-color">Agent Type</td>
            <td>
              {{ testConfig['udp:udp']['engine-b-info']['engine-type'] }}
            </td>
          </tr>
          <tr>
            <td class="test-color">Management Address</td>
            <td>{{ testConfig['udp:udp']['engine-b-info'].address }}</td>
          </tr>
          <tr>
            <td class="test-color">Management Port</td>
            <td>{{ testConfig['udp:udp']['engine-b-info'].port }}</td>
          </tr>

          <tr>
            <td class="test-color">Test Address</td>
            <td>
              {{ testConfig['udp:udp']['engine-b-info']['test-ip'] }}
            </td>
          </tr>
          <tr>
            <td class="test-color">Test Subnet Mask</td>
            <td>
              {{ testConfig['udp:udp']['engine-b-info']['test-subnet-mask'] }}
            </td>
          </tr>
          <tr>
            <td class="test-color">Test Gateway</td>
            <td>
              {{ testConfig['udp:udp']['engine-b-info']['test-gateway'] }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="test-margin">
      <div class="test-font">Test Setup</div>
      <table
        style="width: 70%; border-left: unset; border-right: unset; font-size: 14px"
        class="test-setup-table"
      >
        <tr *ngFor="let attr of testConfigDisplay.overall">
          <td class="test-color" style="width: 30% !important">{{ attr.name }}</td>
          <td>{{ attr.value }}</td>
        </tr>
      </table>
    </div>
  </div>

  <div layout="column" class="page" *ngIf="clientToMa && hasClientInfo && expertView === true">
    <div class="page-break"></div>
    <span class="page-title"> Client configuration</span>
    <nrwl-report-view-table
      [dataSource]="clientInfoDataSource"
      [displayedColumns]="displayedColumns"
    ></nrwl-report-view-table>
    <div layout="column" class="trending-chart-container">
      <div class="grid">
        <div layout="row" class="legend-row">
          <span flex></span>
          <span class="legend"
            >CPU Usage (%)
            <md-icon class="material-icons md-30 cpu-icon diagnosis-head-left">stop</md-icon>
          </span>
        </div>
      </div>
      <nrwl-trending-chart
        [options]="transformService.createCpuChart(clientCpuUsage, 'client')"
        id="cpu-chart"
      ></nrwl-trending-chart>
    </div>
  </div>
  <div layout="column" class="page" *ngIf="clientToMa && hasClientInfo && expertView === true">
    <div class="page-break"></div>
    <div layout="column" class="trending-chart-container">
      <div class="grid">
        <div layout="row" class="legend-row">
          <span flex></span>
          <span class="legend"
            >Memory Usage (%)
            <md-icon class="material-icons md-30 cpu-icon diagnosis-head-left">stop</md-icon>
          </span>
        </div>
      </div>
      <nrwl-trending-chart
        [options]="transformService.createMemoryUsageChart(clientMemoryUsage, 'client')"
        id="memory-chart"
      ></nrwl-trending-chart>
    </div>
  </div>

  <div layout="column" class="page" *ngIf="testConfigDisplay" style="padding-bottom: 50px">
    <div class="page-break"></div>
    <div style="font-size: 14px; font-weight: bold; display: flex; align-items: center">
      <i class="material-icons icon">settings</i>
      <span class="margin-10-left">Streams</span>
    </div>
    <hr />
    <div class="test-margin">
      <!-- <div class="test-font">Streams</div> -->
      <table id="streamsTable" class="streams-table" style="width: 100%; font-size: 14px">
        <!-- Common header row -->
        <thead>
          <tr class="test-color">
            <th>Name</th>
            <th>Direction</th>
            <th>Type</th>
            <th>{{ streamRateConvention }}</th>
            <th>UDP BW</th>
            <th>Frame Size</th>
            <th>Port</th>
            <th>Packet Loss Threshold</th>
            <th>Jitter Threshold</th>
          </tr>
        </thead>
        <tbody>
          <!-- Iterate over each stream to create a row -->
          <tr
            *ngFor="let stream of testConfigDisplay.streams"
            [ngClass]="{
              'aggregate-row-border': stream.name === 'Aggregate',
              'aggregate-row': stream.name === ''
            }"
          >
            <td>{{ stream.name }}</td>
            <td>
              <ng-container *ngIf="stream.mode === 'engine-a-to-engine-b'">
                A <i class="mdi mdi-arrow-right-bold onewayBColor"></i> B
              </ng-container>
              <ng-container *ngIf="stream.mode === 'engine-b-to-engine-a'">
                B <i class="mdi mdi-arrow-right-bold onewayAColor"></i> A
              </ng-container>
              <ng-container
                *ngIf="
                  (stream.mode === 'bidirectional' || stream.mode === 'bidirsequential') &&
                  stream.originator === 'engine-a'
                "
              >
                A <i class="mdi mdi-arrow-right-bold onewayBColor"></i> B
              </ng-container>
              <ng-container
                *ngIf="
                  (stream.mode === 'bidirectional' || stream.mode === 'bidirsequential') &&
                  stream.originator === 'engine-b'
                "
              >
                B <i class="mdi mdi-arrow-right-bold onewayAColor"></i> A
              </ng-container>
            </td>
            <td *ngIf="stream.name === 'Aggregate' || stream.name === ''"></td>
            <td *ngIf="stream.name !== 'Aggregate' && stream.name !== ''">
              {{
                stream['stream-type']
                  ? stream['stream-type']
                  : getStreamType(stream['stream-number'])
              }}
            </td>
            <td>
              <ng-container *ngIf="stream.mode === 'bidirsequential'">
                <div *ngIf="stream.bw !== ''">
                  {{ stream.ulrOrIr | number: '1.2-2' }} <span *ngIf="stream.ulrOrIr">Mbps</span>
                </div>
              </ng-container>
              <ng-container *ngIf="stream.mode === 'bidirsequential'">
                <div *ngIf="stream.bw2 !== ''">
                  {{ stream.ulrOrIr2 | number: '1.2-2' }} <span *ngIf="stream.ulrOrIr2">Mbps</span>
                </div>
              </ng-container>

              <ng-container *ngIf="stream.mode !== 'bidirsequential'">
                <span *ngIf="stream.bw !== ''">
                  {{ stream.ulrOrIr | number: '1.2-2' }} <span *ngIf="stream.ulrOrIr">Mbps</span>
                </span>
              </ng-container>
              <ng-container *ngIf="stream.mode !== 'bidirsequential'">
                <span *ngIf="stream.bw2 !== ''">
                  {{ stream.ulrOrIr2 | number: '1.2-2' }} <span *ngIf="stream.ulrOrIr2">Mbps</span>
                </span>
              </ng-container>
            </td>

            <td>
              <ng-container *ngIf="stream.bw">
                {{ stream.bw | number: '1.2-2' }} Mbps
              </ng-container>
              <ng-container *ngIf="stream.bw2">
                {{ stream.bw2 | number: '1.2-2' }} Mbps
              </ng-container>
            </td>
            <td>
              {{ stream['frame-size'] }}
              <span *ngIf="stream['frame-size'] !== ''">Bytes</span>
            </td>
            <td>{{ stream['udp-port'] }}</td>
            <td>
              {{ stream['packet-loss-ratio-threshold'] }}
              <span *ngIf="stream['packet-loss-ratio-threshold'] !== ''">%</span>
            </td>
            <td>
              {{ stream['jitter-threshold'] }}
              <span *ngIf="stream['jitter-threshold'] !== ''">ms</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    fxLayout="column"
    class="page"
    fxLayoutGap="16px"
    *ngIf="reportmessage && reportmessage?.length !== 0"
  >
    <div class="page-break"></div>

    <mat-toolbar class="diagnosis-head border">
      <div class="mat-toolbar-tools">
        <h2 class="mat-flex">Report Message</h2>
      </div>
    </mat-toolbar>

    <mat-card class="border" fxLayout="column" fxLayoutGap="16px">
      <div fxLayout="row">
        <span>{{ reportmessage }}</span>
      </div>
    </mat-card>
  </div>
</div>

<div class="udp-content">
  <div class="loader-content" *ngIf="loading">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">Getting Reports</div>
    </div>
  </div>
</div>
